module.exports = __webpack_public_path__ + "static/img/13d.2bfaebb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/13d.jpg
// module id = yW+R
// module chunks = 0